import { get as getPathValue } from "lodash";
import type { BlockMetaMapping } from "../../BuilderUI.types";
import type { BaseBlock } from "../../DataModel.types";
import { isBaseBlock } from "../../Helpers/typePredicates";

const getSelectedBlock = ({
  selectedBlockPath,
  getBlocks,
  getBlockMetaMapping,
}: {
  selectedBlockPath: string | null;
  getBlocks: () => BaseBlock;
  getBlockMetaMapping: () => BlockMetaMapping;
}) => {
  if (!selectedBlockPath) return null;
  const blocks = getBlocks();
  const block = getPathValue({ blocks }, selectedBlockPath) as BaseBlock;

  if (!isBaseBlock(block)) return null;

  const meta = getBlockMetaMapping()[block.type];
  return meta ? { block, meta } : null;
};

export default getSelectedBlock;
